import * as Yup from "yup";

export const surveyTemplateValidationSchema = Yup.object({
    name: Yup.string().required("Nombre del template es requerido"),
    whatsappKey: Yup.string().required("Key de whatsapp es requerida"),
    channelType: Yup.string().required("Canal es requerido"),
    defaultTemplate: Yup.boolean().required("Default template es requerido"),
    companyId: Yup.number().required("Compañia es requerida"),
    template: Yup.string().optional(),
    finalMessage: Yup.string().optional(),
    messageNoAnswer: Yup.string().optional()
});
